<template>
  <el-dialog
    title="标签报废"
    :visible.sync="visible"
    width="420px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item label="标签号段:">
        {{ ruleForm.min }} - {{ ruleForm.max }}
      </el-form-item>
      <el-form-item
        label="开始序号:"
        prop="tagNo">
        <el-input-number
          v-model="ruleForm.tagNo"
          style="width: 100%"
          :min="ruleForm.min"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="结束序号:"
        prop="endTagNo">
        <el-input-number
          v-model="ruleForm.endTagNo"
          style="width: 100%"
          :disabled="!ruleForm.tagNo"
          :min="ruleForm.tagNo"
          :max="ruleForm.max"
          :precision="0"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import AppraiseLable from '@/service/appraiseLable'
export default {
  name: 'ApplyTagInvalidModal',
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { tagSegId: null, tagNo: undefined, endTagNo: undefined, min: undefined, max: undefined },
      rules: {
        tagNo: [
          { required: true, message: '请输入开始序号', trigger: 'blur' }
        ],
        endTagNo: [
          { required: true, message: '请输入结束序号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { tagSegId, tagNo, endTagNo } = this.ruleForm
          if (endTagNo < tagNo) {
            this.$message.error('结束序号不能小于开始序号')
            return
          }
          this.loading = true
          const tagSegs = [{ beginTagNo: tagNo, endTagNo }]
          AppraiseLable.scraptags({ tagSegId, tagSegs })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.visible = false
                this.$message.success('作废成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
